<template>
    <div class="signer-form">
        <el-button size="small" style="margin-bottom: 25px;" type="primary" @click="openModal">{{$t('Yeni_təsdiqləyici')}}</el-button>
        <el-table :data="signers" style="width: 100%" v-loading="loadingTable">
            <el-table-column prop="userName" :label="$t('A.S.A')" width="200"></el-table-column>
            <el-table-column :label="$t('Rol')" width="300">
                <template slot-scope="scope">
                    {{ getRoleName(scope.row.roleId) }}
                </template>
            </el-table-column>
            <el-table-column prop="fromPrice" :label="$t('Məbləğdən')" width="200"></el-table-column>
            <el-table-column prop="toPrice" :label="$t('Məbləğə')" width="220"></el-table-column>
            <el-table-column prop="orderIndex" :label="$t('Təsdiq_sırası')" width="120"></el-table-column>
            <el-table-column label="Active?">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.isActive" @change="handleStatusChange(scope.row)"
                        active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </template>
            </el-table-column>
            <el-table-column align="right" fixed="right" width="50">
                <template slot-scope="scope">
                    <el-dropdown trigger="click">
                        <el-button type="text" class="custom-button" style="padding: 0 10px 0 0 !important;">
                            <div class="square-icon">
                                <i class="fas fa-ellipsis-h" :title="$t('Əməliyyatlar')" style="color: #808080;"></i>
                            </div>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="editSigner(scope.row)">
                                <i class="fa-solid fa-pen-to-square"></i>{{$t('Düzəliş')}}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="checkAndDeleteSigner(scope.row)">
                                <i class="fa-solid fa-trash"></i>{{$t('Sil')}}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog :title="$t('Yeni_təsdiqləyici')" :visible.sync="dialogVisible" width="40%" v-loading="loading">
            <el-form ref="signerForm" :model="signer" label-width="120px" :label-position="labelPosition" size="small"
                :rules="rules">
                <div class="row">
                    <div class="col-12">
                        <el-form-item :label="$t('Təsdiqləyicilər')" prop="uId">
                            <signer-users v-model="signer.uId" />
                        </el-form-item>
                        <el-form-item label="Rol:" prop="selectedRole">
                            <el-select :placeholder="$t('Seçin')" v-model="selectedRole" style="width: 100%">
                                <el-option v-for="role in userRoles" :key="role.id" :label="role.name" :value="role.id">
                                    {{ role.name }}
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('Məbləğdən')" prop="fromPrice">
                            <el-input v-model="signer.fromPrice" type="number"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Məbləğə')" prop="toPrice">
                            <el-input v-model="signer.toPrice" type="number"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Təsdiq_sırası')" type="number" prop="orderIndex">
                            <el-input v-model="signer.orderIndex"></el-input>
                        </el-form-item>
                        <el-form-item class="text-right">
                            <el-button size="small" type="primary" @click="submitForm">{{$t('Yadda_saxla')}}</el-button>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog title="Təsdiqləyici seçin" :visible.sync="reassignDialogVisible" width="30%">
            <signer-users v-model="newSignerUid"></signer-users>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="primary"
                    @click="reassignApprovals">{{$t('Təsdiqləyicini_dəyiş')}}</el-button>
                <el-button size="small" class="btn-danger"
                    @click="reassignDialogVisible = false">{{$t('İmtina')}}</el-button>
            </span>
        </el-dialog>
        <el-dialog title="Təsdiqləyici seçin" :visible.sync="deleteDialogVisible" width="30%">
            <signer-users v-model="newSignerUid"></signer-users>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="primary"
                    @click="deleteSigner(signer)">{{$t('Təsdiqləyicini_dəyiş')}}</el-button>

                <el-button size="small" class="btn-danger"
                    @click="deleteDialogVisible = false">{{$t('İmtina')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { InsertSigner, GetAllSigners, UpdateSigner, CheckPendingApprovals, UpdateSignerStatus, DeleteSigner } from "../../services/signers";
    import SignerUsers from "../components/SignerUsers.vue";
    import { labelPosition } from "../../services/helper";
    export default {
        data() {
            return {
                loading: false,
                loadingTable: false,
                dialogVisible: false,
                deleteDialogVisible: false,
                signers: [],
                signer: {
                    id: null,
                    uId: null,
                    roleId: '',
                    fromPrice: '',
                    toPrice: '',
                    orderIndex: '',
                    isActive: true,
                },
                uid: this.$store.state.user.id,
                userRoles: [
                    { id: 63, name: "Assistant Director of ICD" },
                    { id: 64, name: "Director of ICD" },
                    { id: 65, name: "Assistant Chairman" },
                    { id: 66, name: "Advisor" },
                    { id: 79, name: "Inspection Commission Operator 1" },
                    { id: 80, name: "Inspection Commission Operator 2" },
                    { id: 81, name: "Manager of ICAD" },
                ],
                selectedRole: null,
                rules: {
                    fromPrice: [{ required: true, message: "Sütun mütləqdir!", trigger: "blur" }],
                    toPrice: [{ required: true, message: "Sütun mütləqdir!", trigger: "blur" }],
                    orderIndex: [{ required: true, message: "Sütun mütləqdir!", trigger: "blur" }],
                    uId: [{ required: true, message: "Sütun mütləqdir!", trigger: "blur" }],
                },
                reassignDialogVisible: false,
                pendingSigner: null,
                newSignerUid: null,
                labelPosition: labelPosition,
            };
        },
        components: {
            SignerUsers
        },
        methods: {
            checkAndDeleteSigner(signer) {
                CheckPendingApprovals(signer.uId).then(response => {
                    if (response.data.data.value > 0) {
                        this.pendingSigner = signer;
                        this.deleteDialogVisible = true;
                    } else {
                        this.pendingSigner = signer;
                        this.deleteSigner(signer);
                    }
                }).catch(error => {
                    this.$message.error("Xəta baş verd1i! " + error.message);
                });
            },
            deleteSigner(signer) {
                DeleteSigner(this.pendingSigner.id, this.uid, this.pendingSigner.uId, this.newSignerUid).then(() => {
                    this.$message.success('Uğurlu əməliyyat!');
                    this.fetchSigners();  // Refresh
                    this.deleteDialogVisible = false;
                }).catch(error => {
                    this.$message.error('Xəta baş verdi' + error.message);
                });
            },
            handleStatusChange(signer) {
                if (!signer.isActive) {   
                    CheckPendingApprovals(signer.uId).then(response => {
                        if (response.data.data.value > 0) {
                            this.pendingSigner = signer;
                            this.reassignDialogVisible = true;
                        } else {
                            this.updateSignerStatus(signer); 
                        }
                    }).catch(error => {
                        this.$message.error('Xəta baş verdi ' + error.message);
                    });
                }
                else {
                    this.updateSignerStatus(signer);
                }
            },
            updateSignerStatus(signer) {
                UpdateSignerStatus(signer).then(() => {
                }).catch(error => {
                    this.$message.error("Failed to update signer's status.");
                });
            },
            reassignApprovals() {
                if (this.newSignerUid) {
                    UpdateSignerStatus({ ...this.pendingSigner, newSignerUid: this.newSignerUid, isActive: false }).then(() => {
                        this.reassignDialogVisible = false;
                        this.fetchSigners(); 
                        this.$message.success("Uğurlu əməliyyat!");
                    }).catch(error => {
                        this.$message.error('Xəta baş verdi ' + error.message);
                    });
                }
                else {
                    this.$message.error("Təsdiqləyici seçin!");
                }
            },
            getRoleName(roleId) {
                const role = this.userRoles.find(r => r.id === roleId);
                return role ? role.name : 'N/A';
            },
            openModal() {
                this.resetSigner();
                this.dialogVisible = true;
            },
            fetchSigners() {
                this.loadingTable = true;
                GetAllSigners().then(response => {
                    this.signers = response.data;
                }).finally(() => {
                    this.loadingTable = false;
                });
            },
            editSigner(signer) {
                this.signer = { ...signer };
                this.selectedRole = signer.roleId;
                this.uId = signer.uId;
                this.dialogVisible = true;
            },
            submitForm() {
                if (!this.selectedRole) {
                    this.$message({ type: "error", message: "Rol seçin!" });
                    return;
                }
                this.$refs.signerForm.validate(valid => {
                    if (valid) {
                        this.signer.id ? this.updateSigner() : this.saveSigner();
                    } else {
                        this.$message({ type: "error", message: "Mütləq sütun!" });
                    }
                });
            },
            saveSigner() {
                const signerData = {
                    roleId: parseInt(this.selectedRole, 10),
                    uId: this.signer.uId,
                    fromPrice: parseFloat(this.signer.fromPrice),
                    toPrice: parseFloat(this.signer.toPrice),
                    orderIndex: parseInt(this.signer.orderIndex, 10),
                    isActive: this.signer.isActive,
                };
                InsertSigner(signerData).then(() => {
                    this.$message({ type: "success", message: "Uğurlu Əməliyyat!" });
                    this.dialogVisible = false;
                    this.fetchSigners();
                }).catch(() => {
                    this.$message({ type: "error", message: "Failed to create signer." });
                });
            },
            updateSigner() {
                const signerData = {
                    id: this.signer.id,
                    roleId: parseInt(this.selectedRole, 10),
                    uId: (this.signer.uId),
                    fromPrice: parseFloat(this.signer.fromPrice),
                    toPrice: parseFloat(this.signer.toPrice),
                    orderIndex: parseInt(this.signer.orderIndex, 10),
                    isActive: this.signer.isActive,
                };
                UpdateSigner(signerData).then(() => {
                    this.dialogVisible = false;
                    this.$message({ type: "success", message: "Uğurlu Əməliyyat!" });
                    this.fetchSigners();
                }).catch(() => {
                    this.$message({ type: "error", message: "Xəta baş verdi!" });
                });
            },
            resetSigner() {
                this.signer = {
                    id: null,
                    roleId: '',
                    fromPrice: '',
                    toPrice: '',
                    orderIndex: '',
                    isActive: true,
                };
                this.selectedRole = null;
            }
        },
        watch: {
            dialogVisible(newValue) {
                if (!newValue) {
                    this.resetSigner();
                    this.$refs.signerForm.resetFields();
                    this.fetchSigners();
                }
            },
            reassignDialogVisible(newValue) {
                if (!newValue) {
                    this.fetchSigners();
                }
            },
        },
        mounted() {
            this.fetchSigners();
        }
    };
</script>